import React from "react";
import { Icon, Card, Tag, Typography } from "@ann/web-components";
import SuggestionItem from "../SuggestionItem";
import {
  GroupHeader,
  GroupHeaderLeft,
  GroupHeaderRight,
  ChevronIcon,
  GroupContent,
  GroupContainer,
} from "./SuggestionGroupSection.styled";

const SuggestionGroupSection = ({
  group,
  isExpanded = false,
  onToggle,
  onApprove,
  onDecline,
}) => {
  const { title, suggestions = [], id } = group;
  const suggestionsCount = suggestions.length;

  return (
    <GroupContainer>
      <GroupHeader onClick={onToggle}>
        <GroupHeaderLeft>
          <Typography category="subtitle" size="medium" weight="bold" color="title">
            {title}
          </Typography>
          
          <Tag
            color="informative"
            size="medium"
            text={`${suggestionsCount} option${
              suggestionsCount !== 1 ? "s" : ""
            }`}
          />
        </GroupHeaderLeft>
        <GroupHeaderRight>
          <ChevronIcon $isExpanded={isExpanded}>
            <Icon name="chevronDown" size="medium" />
          </ChevronIcon>
        </GroupHeaderRight>
      </GroupHeader>

      {isExpanded && (
        <GroupContent>
          {suggestions.map((suggestion) => (
            <SuggestionItem
              key={suggestion.suggestion_uuid}
              suggestion={suggestion}
              groupId={id}
              onApprove={onApprove}
              onDecline={onDecline}
            />
          ))}
        </GroupContent>
      )}
    </GroupContainer>
  );
};

export default SuggestionGroupSection;
